<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <draw-list-table></draw-list-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import drawListTable from './DrawListTable.vue'

  export default {
    name: 'draw-list',
    components: {drawListTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/drawlist/DrawList.vue